import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, push, onValue, serverTimestamp, onDisconnect, remove, get, update } from "firebase/database";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
const firebaseConfig = {
  apiKey: "AIzaSyDaf9dAdFadmaHDfG-JXoYRvG90xM-ERVg",
  authDomain: "blackchat-c676c.firebaseapp.com",
  databaseURL: "https://blackchat-c676c-default-rtdb.firebaseio.com",
  projectId: "blackchat-c676c",
  storageBucket: "blackchat-c676c.firebasestorage.app",
  messagingSenderId: "653825711440",
  appId: "1:653825711440:web:955800452cc4505b572055"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const messaging = getMessaging(app);

export const getFCMToken = async (username) => { // userId ki jagah username lo
  try {
    if (!('Notification' in window)) {
      console.log('Browser notifications support nahi karta');
      return null;
    }

    if (!('serviceWorker' in navigator)) {
      console.log('Service Worker support nahi hai');
      return null;
    }
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('SW registered:', registration.scope);
    await navigator.serviceWorker.ready;
    console.log('SW ready ho gaya');
    const permission = await Notification.requestPermission();
    if (permission!== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: 'BHL1cSPzaknNJIIjrpC0C2Ai_88B1qIDNdAtobM-tHKZXDX50FySH_1jpO447_9TbKILqKiD6pfO52Gh8TF-6jo',
      serviceWorkerRegistration: registration
    });

    if (token) {
      console.log('FCM Token mil gaya:', token);
      // uid ki jagah username use karo
      await update(ref(db, `users/${username}`), {
        fcmToken: token,
        tokenUpdatedAt: Date.now()
      });
      return token;
    } else {
      console.log('Token nahi mila');
      return null;
    }
  } catch (err) {
    console.log('Token error:', err);
    return null;
  }
};
const auth = getAuth(app);
const CLOUDINARY_CLOUD_NAME = "djadhauhp";
const CLOUDINARY_UPLOAD_PRESET = "chatzooo_unsigned";

function App() {
  const [uploadProgress, setUploadProgress] = useState({});
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [isRecordingOther, setIsRecordingOther] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [nameInput, setNameInput] = useState("");
  const [passInput, setPassInput] = useState("");
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [msgInput, setMsgInput] = useState("");
  const [users, setUsers] = useState({});
  const [contacts, setContacts] = useState({});
  const [allChats, setAllChats] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUserName, setNewUserName] = useState("");
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordTime, setRecordTime] = useState("0:00");
  const [callModal, setCallModal] = useState({ active: false, name: '', status: '', incoming: false });
  const [toast, setToast] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeEmojiTab, setActiveEmojiTab] = useState('emoji');
  const [gifResults, setGifResults] = useState([]);
  const [stickerResults, setStickerResults] = useState([]);
  const [lastMessages, setLastMessages] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const [showAttachmentMenu, setShowAttachmentMenu] = useState(false);
  const [previewModal, setPreviewModal] = useState({ active: false, type: '', url: '', name: '' });
  const [profileTab, setProfileTab] = useState('profile');
  const [userProfile, setUserProfile] = useState({
    name: '',
    about: 'Hey there! I am using ChatZooo',
    profilePic: '',
    privacy: {
      lastSeen: 'everyone',
      profilePhoto: 'everyone',
      about: 'everyone',
      readReceipts: true
    }
  });

  const messagesEndRef = useRef(null);
  const peerRef = useRef(null);
  const currentCallRef = useRef(null);
  const localStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recordTimerRef = useRef(null);
  const recordStartTimeRef = useRef(0);
  const callTimerRef = useRef(null);
  const callSecondsRef = useRef(0);
  const listenersRef = useRef({});
  const ringtoneRef = useRef(null);
  const currentAudioRef = useRef(null);
  const micPermissionGrantedRef = useRef(false);
  const emojiPickerLoaded = useRef(false);
  const emojiPickerRef = useRef(null);
  const activeChatRef = useRef(null);
  const deliveredListenerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (emojiPickerRef.current &&!emojiPickerRef.current.contains(e.target)) {
        setIsEmojiPickerOpen(false);
      }
      if (!e.target.closest('.attachment-wrapper')) {
        setShowAttachmentMenu(false);
      }
    };

    if (isEmojiPickerOpen || showAttachmentMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isEmojiPickerOpen, showAttachmentMenu]);

  useEffect(() => {
    if (!activeChat ||!currentUser) {
      setIsTyping(false);
      return;
    }
    const chatId = [currentUser, activeChat].sort().join('_');
    const typingRef = ref(db, `chats/${chatId}/typing`);

    const unsub = onValue(typingRef, (snapshot) => {
      const typingData = snapshot.val() || {};
      const otherUserTyping = Object.keys(typingData).find(
        uid => uid!== currentUser && typingData[uid] === true
      );
      setIsTyping(!!otherUserTyping);
    });

    return () => unsub();
  }, [activeChat, currentUser]);

  useEffect(() => {
    if (!activeChat ||!currentUser) {
      setIsRecordingOther(false);
      return;
    }

    const chatId = [currentUser, activeChat].sort().join('_');
    const recordingRef = ref(db, `chats/${chatId}/recording`);

    const unsub = onValue(recordingRef, (snapshot) => {
      const recordingData = snapshot.val() || {};
      const otherUserRecording = Object.keys(recordingData).find(
        uid => uid!== currentUser && recordingData[uid] === true
      );
      setIsRecordingOther(!!otherUserRecording);
    });

    return () => unsub();
  }, [activeChat, currentUser]);

  useEffect(() => {
    activeChatRef.current = activeChat;
  }, [activeChat]);

  useEffect(() => {
  if (!currentUser) return;

  // Foreground me FCM message aaye to handle karo
  const unsubscribe = onMessage(messaging, (payload) => {
    console.log('Foreground FCM message:', payload);

    if (payload.data?.type === 'call') {
      const callerName = payload.data.callerName;
      const chatId = payload.data.chatId;

      // Ringtone bajao
      if (ringtoneRef.current) {
        ringtoneRef.current.play().catch(e => console.log('Audio play failed:', e));
      }

      // Call modal dikhao
      setCallModal({
        active: true,
        name: callerName,
        status: 'Incoming call...',
        incoming: true
      });

      // Browser notification bhi dikhao
      if (Notification.permission === 'granted') {
        new Notification(`${callerName} is calling...`, {
          body: 'Tap to answer',
          icon: '/logo192.png',
          requireInteraction: true,
          tag: 'call-' + chatId
        });
      }
    }
  });

  return () => unsubscribe();
}, [currentUser]);

  useEffect(() => {
    signInAnonymously(auth).catch(err => console.log('Auth error:', err));

    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('Logged in as:', user.uid);
      }
    });

    const savedUser = localStorage.getItem('blackchat_user');
    const savedPass = localStorage.getItem('blackchat_pass');
    if (savedUser && savedPass) {
      setNameInput(savedUser);
      setPassInput(savedPass);
      login(savedUser, savedPass);
    }
    document.addEventListener('gesturestart', e => e.preventDefault());

    return () => {
      if (localStreamRef.current) localStreamRef.current.getTracks().forEach(t => t.stop());
      if (peerRef.current) peerRef.current.destroy();
      Object.values(listenersRef.current).forEach(unsub => unsub && unsub());
      if (deliveredListenerRef.current) deliveredListenerRef.current();
    };
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping, isRecordingOther]);

  useEffect(() => {
    if (activeEmojiTab === 'emoji' && isEmojiPickerOpen) {
      emojiPickerLoaded.current = false;
      setTimeout(() => initEmojiPicker(), 50);
    }
  }, [activeEmojiTab, isEmojiPickerOpen]);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 3000);
  };

  const loadUserProfile = async (username) => {
    const profileSnap = await get(ref(db, `profiles/${username}`));
    if (profileSnap.exists()) {
      setUserProfile(profileSnap.val());
    } else {
      const defaultProfile = {
        name: username,
        about: 'Hey there! I am using ChatZooo',
        profilePic: '',
        phone: '',
        privacy: { lastSeen: 'everyone', profilePhoto: 'everyone', about: 'everyone', readReceipts: true }
      };
      await set(ref(db, `profiles/${username}`), defaultProfile);
      setUserProfile(defaultProfile);
    }
  };

  const updateProfile = (key, value) => {
    const updated = {...userProfile, [key]: value };
    setUserProfile(updated);
    update(ref(db, `profiles/${currentUser}`), { [key]: value });
  };

  const updatePrivacy = (key, value) => {
    const updated = {...userProfile, privacy: {...userProfile.privacy, [key]: value } };
    setUserProfile(updated);
    update(ref(db, `profiles/${currentUser}/privacy`), { [key]: value });
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) return showToast('Image too large. Max 2MB');

    const reader = new FileReader();
    reader.onloadend = () => {
      updateProfile('profilePic', reader.result);
      showToast('Profile photo updated');
    };
    reader.readAsDataURL(file);
  };

  const initEmojiPicker = () => {
    if (emojiPickerLoaded.current) return;
    if (typeof window.EmojiMart === 'undefined') {
      setTimeout(initEmojiPicker, 200);
      return;
    }
    const emojiContent = document.getElementById('emojiContent');
    if (!emojiContent || emojiContent.children.length > 0) return;

    emojiContent.innerHTML = '';

    const picker = new window.EmojiMart.Picker({
      onEmojiSelect: (emoji) => {
        setMsgInput(prev => prev + emoji.native);
        setIsEmojiPickerOpen(false);
      },
      theme: 'dark',
      previewPosition: 'none',
      skinTonePosition: 'none',
      perLine: 8
    });
    emojiContent.appendChild(picker);
    emojiPickerLoaded.current = true;
  };

  const loadGifs = async (query, type = 'gif') => {
    const setResults = type === 'sticker'? setStickerResults : setGifResults;
    setResults([{ loading: true }]);

    try {
      const key = 'GlVGYHkr3WSBnllca54iNt0yFbjz7L65';
      const endpoint = type === 'sticker'? 'stickers' : 'gifs';
      const url = `https://api.giphy.com/v1/${endpoint}/search?api_key=${key}&q=${encodeURIComponent(query)}&limit=15&rating=g`;

      const res = await fetch(url);
      const data = await res.json();

      const formatted = data.data.map(item => ({
        media_formats: {
          tinygif: { url: item.images.fixed_height_small.url },
          gif: { url: item.images.original.url }
        }
      }));

      setResults(formatted);
    } catch (err) {
      console.error('Giphy Error:', err);
      showToast('Failed to load');
      setResults([]);
    }
  };

  const sendGif = (url) => {
    if (!activeChat) return;
    const chatId = [currentUser, activeChat].sort().join('_');
    push(ref(db, `chats/${chatId}`), {
      sender: currentUser,
      type: 'gif',
      url: url,
      time: Date.now(),
      status: 'sent'
    });
    setIsEmojiPickerOpen(false);
  };

  useEffect(() => {
    if (activeChat) {
      markAsSeen(activeChat);
    }
  }, [activeChat, messages]);

  const login = async (name = nameInput, pass = passInput) => {
    if (!name.trim()) return showToast('Please enter username');
    if (name.length < 3) return showToast('Username must be at least 3 characters');
    if (!pass.trim()) return showToast('Please enter password');
    if (pass.length < 4) return showToast('Password must be at least 4 characters');

    const authUser = auth.currentUser || (await signInAnonymously(auth)).user;

    if (location.protocol!== 'https:' && location.hostname!== 'localhost' && location.hostname!== '127.0.0.1') {
      return showToast('HTTPS required. Deploy first.');
    }

    showToast('Logging in...');

    const userSnap = await get(ref(db, `users/${name}`));
    if (userSnap.exists()) {
      const userData = userSnap.val();
      if (userData.password!== pass) return showToast('Wrong password!');
    } else {
      await set(ref(db, `users/${name}`), {
        name: name,
        password: pass,
        uid: authUser.uid,
        online: true,
        lastSeen: serverTimestamp()
      });
    }

    setCurrentUser(name);
    localStorage.setItem('blackchat_user', name);
    localStorage.setItem('blackchat_pass', pass);
    await set(ref(db, `userMap/${authUser.uid}`), name);

    await loadUserProfile(name);
    await initPeer(name);
    setupPresence(name);
    await initApp(name);

try {
  await getFCMToken(name); 
} catch (err) {
  console.log('FCM skip:', err);
}
  };

  const initPeer = (username) => {
    return new Promise((resolve) => {
      if (peerRef.current) peerRef.current.destroy();

      const peerId = username.replace(/[^a-zA-Z0-9]/g, '') + '_' + Date.now();
      peerRef.current = new window.Peer(peerId, {
        host: '0.peerjs.com',
        port: 443,
        path: '/',
        secure: true,
        config: {
          iceServers: [
            { urls: 'stun:stun.l.google.com:19302' },
            { urls: 'stun:stun1.l.google.com:19302' },
            { urls: 'turn:openrelay.metered.ca:80', username: 'openrelayproject', credential: 'openrelayproject' },
            { urls: 'turn:openrelay.metered.ca:443', username: 'openrelayproject', credential: 'openrelayproject' }
          ],
          iceCandidatePoolSize: 10
        }
      });

      peerRef.current.on('open', (id) => {
        update(ref(db, `users/${username}`), {
          peerId: id,
          online: true,
          lastSeen: serverTimestamp()
        });
        resolve();
      });

      peerRef.current.on('call', (call) => {
        if (currentCallRef.current) {
          call.close();
          return;
        }
        currentCallRef.current = call;
      });

      peerRef.current.on('error', (err) => {
        console.error('Peer error:', err);
        if (err.type === 'peer-unavailable') showToast('User not available');
      });
    });
  };

  const setupPresence = (username) => {
    const connectedRef = ref(db, '.info/connected');
    onValue(connectedRef, (snap) => {
      if (snap.val() === true) {
        update(ref(db, `users/${username}`), {
          online: true,
          lastSeen: serverTimestamp()
        });
        onDisconnect(ref(db, `users/${username}/online`)).set(false);
        onDisconnect(ref(db, `users/${username}/lastSeen`)).set(serverTimestamp());
        markAllAsDelivered(username);
      }
    });
  };

  const markAllAsDelivered = (username) => {
    if (deliveredListenerRef.current) deliveredListenerRef.current();

    deliveredListenerRef.current = onValue(ref(db, 'chats'), (snapshot) => {
      const allChatsData = snapshot.val() || {};
      const updates = {};

      Object.keys(allChatsData).forEach(chatId => {
        if (chatId.includes(username)) {
          const msgs = allChatsData[chatId];
          Object.entries(msgs).forEach(([msgId, msg]) => {
            if (msg && msg.sender!== username && msg.status === 'sent') {
              updates[`chats/${chatId}/${msgId}/status`] = 'delivered';
            }
          });
        }
      });

      if (Object.keys(updates).length > 0) {
        update(ref(db), updates);
      }
    });
  };

  const initApp = (username) => {
   

    loadUsers();
    loadContacts(username);
    loadAllChats(username);
    listenForCalls(username);
  };

  const loadUsers = () => {
    if (listenersRef.current.users) listenersRef.current.users();
    listenersRef.current.users = onValue(ref(db, 'users'), async (snapshot) => {
      const usersData = snapshot.val() || {};

      for (const username in usersData) {
        const profileSnap = await get(ref(db, `profiles/${username}`));
        if (profileSnap.exists()) {
          const profileData = profileSnap.val();
          usersData[username] = {...usersData[username],...profileData };

          const lastSeenPrivacy = profileData.privacy?.lastSeen || 'everyone';
          if (username!== currentUser) {
            if (lastSeenPrivacy === 'nobody') {
              delete usersData[username].lastSeen;
              delete usersData[username].online;
            } else if (lastSeenPrivacy === 'contacts' &&!contacts[username]) {
              delete usersData[username].lastSeen;
              delete usersData[username].online;
            }
          }
        }
      }

      setUsers(usersData);
    });
  };

  const loadContacts = (username) => {
    if (listenersRef.current.contacts) listenersRef.current.contacts();
    listenersRef.current.contacts = onValue(ref(db, `contacts/${username}`), (snapshot) => {
      setContacts(snapshot.val() || {});
    });
  };

  const loadAllChats = (username) => {
    if (listenersRef.current.allChats) listenersRef.current.allChats();
    listenersRef.current.allChats = onValue(ref(db, 'chats'), (snapshot) => {
      const allChatsData = snapshot.val() || {};
      const newAllChats = {};
      const newLastMsgs = {};

      Object.keys(allChatsData).forEach(chatId => {
        if (chatId.includes(username)) {
          const otherUser = chatId.split('_').find(u => u!== username);
          if (otherUser) {
            newAllChats[otherUser] = true;
            const msgs = allChatsData[chatId];
            if (msgs) {
              const validMsgs = Object.values(msgs).filter(m => m && typeof m === 'object');
              const sorted = validMsgs.sort((a, b) => (b.time || 0) - (a.time || 0));
              newLastMsgs[otherUser] = sorted[0];
            }
          }
        }
      });
      setAllChats(newAllChats);
      setLastMessages(newLastMsgs);
    });
  };

  const listenForCalls = (username) => {
    if (listenersRef.current.calls) listenersRef.current.calls();
    listenersRef.current.calls = onValue(ref(db, `calls/${username}`), (snapshot) => {
      const callData = snapshot.val();
      if (callData && callData.status === 'calling' &&!callModal.active) {
        showIncomingCall(callData.from);
      } else if (!callData && callModal.active) {
        endCallUI();
      }
    });
  };

  const logout = () => {
    if (confirm('Logout?')) {
      update(ref(db, `users/${currentUser}`), { online: false });
      if (peerRef.current) peerRef.current.destroy();
      if (localStreamRef.current) localStreamRef.current.getTracks().forEach(t => t.stop());
      localStorage.removeItem('blackchat_user');
      localStorage.removeItem('blackchat_pass');
      location.reload();
    }
  };

  const addUser = async () => {
    const name = newUserName.trim();
    if (!name) return showToast('Enter a username');
    if (name === currentUser) return showToast('You cannot add yourself');

    showToast('Searching user...');
    try {
      const userSnap = await get(ref(db, `users/${name}`));
      if (!userSnap.exists()) return showToast('User not found. Ask them to refresh and login.');

      await set(ref(db, `contacts/${currentUser}/${name}`), true);
      showToast(`Added ${name} to contacts`);
      setIsModalOpen(false);
      setNewUserName('');
      openChat(name);
    } catch (err) {
      showToast('Error adding user');
    }
  };

  const openChat = async (username) => {
    const userSnap = await get(ref(db, `users/${username}`));
    if (!userSnap.exists()) return showToast('User does not exist');

    setActiveChat(username);
    loadMessages(username);
  };

  const closeChatMobile = () => {
    setActiveChat(null);
  };

  const markAsSeen = (otherUser) => {
    const chatId = [currentUser, otherUser].sort().join('_');

    get(ref(db, `chats/${chatId}`)).then((snapshot) => {
      const msgs = snapshot.val();
      if (!msgs) return;

      const updates = {};
      Object.entries(msgs).forEach(([msgId, msg]) => {
        if (msg && msg.sender === otherUser && msg.status === 'delivered') {
          updates[`chats/${chatId}/${msgId}/status`] = 'seen';
        }
      });

      if (Object.keys(updates).length > 0) {
        update(ref(db), updates);
      }
    });
  };

  const loadMessages = (username) => {
    const chatId = [currentUser, username].sort().join('_');
    const key = `msgs_${username}`;

    if (listenersRef.current[key]) listenersRef.current[key]();

    listenersRef.current[key] = onValue(ref(db, `chats/${chatId}`), (snapshot) => {
      const msgs = snapshot.val();
      if (!msgs) {
        setMessages([]);
        return;
      }
      const validMsgs = Object.values(msgs).filter(m => m && typeof m === 'object');
      const sorted = validMsgs.sort((a, b) => (a.time || 0) - (b.time || 0));
      setMessages(sorted);

      if (activeChatRef.current === username) {
        markAsSeen(username);
      }
    });
  };

  const handleTyping = () => {
    if (!activeChat ||!currentUser) return;

    const chatId = [currentUser, activeChat].sort().join('_');
    const typingRef = ref(db, `chats/${chatId}/typing/${currentUser}`);

    set(typingRef, true);

    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(() => {
      set(typingRef, false);
    }, 2000);

    setTypingTimeout(timeout);
  };

  const sendMessage = async () => {
  if (!msgInput.trim() ||!activeChat) return;
  const chatId = [currentUser, activeChat].sort().join('_');
  const messageText = msgInput;

  push(ref(db, `chats/${chatId}`), {
    sender: currentUser,
    text: messageText,
    type: 'text',
    time: Date.now(),
    status: 'sent'
  });

  setMsgInput('');

  try {
    const receiverDoc = await get(ref(db, `users/${activeChat}`));
    const receiverToken = receiverDoc.val()?.fcmToken;
    console.log('Receiver token:', receiverToken?.slice(0,20)); // ye dekho

    if (receiverToken) {
      const res = await fetch('https://yhfuowcodysbsmosgybq.supabase.co/functions/v1/send-notification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          receiverToken: receiverToken,
          senderName: userProfile.name || currentUser,
          messageText: messageText,
          chatId: chatId
        })
      });
      const data = await res.json();
      console.log('Supabase function response:', data); // ye most important hai
    }
  } catch (err) {
    console.log('Notification error:', err);
  }
};

  const generateImageThumbnail = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxSize = 250;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxSize) {
              height = height * (maxSize / width);
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width = width * (maxSize / height);
              height = maxSize;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', 0.7));
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const generateVideoThumbnail = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.muted = true;
      video.playsInline = true;

      video.onloadedmetadata = () => {
        video.currentTime = 1;
      };

      video.onseeked = () => {
        const canvas = document.createElement('canvas');
        const maxSize = 250;
        let width = video.videoWidth;
        let height = video.videoHeight;

        if (width > height) {
          if (width > maxSize) {
            height = height * (maxSize / width);
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = width * (maxSize / height);
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(video, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', 0.7));
        URL.revokeObjectURL(video.src);
      };

      video.onerror = () => {
        reject('Video load error');
      };

      video.src = URL.createObjectURL(file);
    });
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 25 * 1024 * 1024) {
      showToast('File too large. Max 25MB');
      return;
    }
    uploadToCloudinary(file);
    e.target.value = '';
  };

  const uploadToCloudinary = async (file) => {
    if (!activeChat) return showToast('Select a chat first');

    const chatId = [currentUser, activeChat].sort().join('_');
    const tempMsgRef = push(ref(db, `chats/${chatId}`));
    const tempMsgId = tempMsgRef.key;

    let thumbnail = null;
    try {
      if (file.type.startsWith('video/')) {
        thumbnail = await generateVideoThumbnail(file);
      } else if (file.type.startsWith('image/')) {
        thumbnail = await generateImageThumbnail(file);
      }
    } catch (err) {
      console.error('Thumbnail error:', err);
    }

    set(tempMsgRef, {
      sender: currentUser,
      type: file.type.startsWith('image')? 'image' :
        file.type.startsWith('video')? 'video' :
          file.type.startsWith('audio')? 'audio' : 'document',
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type,
      thumbnail: thumbnail,
      uploading: true,
      progress: 0,
      time: Date.now(),
      status: 'sent'
    });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        const progress = Math.round((e.loaded / e.total) * 100);
        setUploadProgress(prev => ({...prev, [tempMsgId]: progress }));
        update(ref(db, `chats/${chatId}/${tempMsgId}`), { progress });
      }
    });

    xhr.addEventListener('load', () => {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        update(ref(db, `chats/${chatId}/${tempMsgId}`), {
          url: data.secure_url,
          uploading: false,
          progress: 100
        });
        setUploadProgress(prev => {
          const newProg = {...prev };
          delete newProg[tempMsgId];
          return newProg;
        });
      } else {
        throw new Error('Upload failed');
      }
    });

    xhr.addEventListener('error', () => {
      showToast('Upload failed');
      remove(ref(db, `chats/${chatId}/${tempMsgId}`));
    });

    xhr.open('POST', `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/auto/upload`);
    xhr.send(formData);
    setShowAttachmentMenu(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' &&!e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const attachmentOptions = [
    { icon: 'ri-image-line', label: 'Gallery', color: '#BF59CF', action: () => imageInputRef.current?.click() },
    {
      icon: 'ri-camera-line', label: 'Camera', color: '#0DAB76', action: () => {
        const input = imageInputRef.current;
        if (input) {
          input.setAttribute('capture', 'environment');
          input.click();
        }
      }
    },
    { icon: 'ri-file-line', label: 'Document', color: '#5157AE', action: () => fileInputRef.current?.click() },
    {
      icon: 'ri-music-2-line', label: 'Audio', color: '#F4B400', action: () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'audio/*';
        input.onchange = handleFileSelect;
        input.click();
      }
    }
  ];

  const startRecording = async (e) => {
    if (e) e.preventDefault();
    if (isRecording ||!activeChat) return showToast('Select a chat first');

    try {
      if (!localStreamRef.current ||!micPermissionGrantedRef.current) {
        localStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
        micPermissionGrantedRef.current = true;
      }

      mediaRecorderRef.current = new MediaRecorder(localStreamRef.current);
      audioChunksRef.current = [];
      setIsRecording(true);
      recordStartTimeRef.current = Date.now();

      mediaRecorderRef.current.ondataavailable = (e) => audioChunksRef.current.push(e.data);
      mediaRecorderRef.current.onstop = () => {
        const duration = Math.round((Date.now() - recordStartTimeRef.current) / 1000);
        const chatId = [currentUser, activeChat].sort().join('_');
        set(ref(db, `chats/${chatId}/recording/${currentUser}`), false);
        if (duration > 0.5) sendVoiceMessage(duration);
      };

      const chatId = [currentUser, activeChat].sort().join('_');
      set(ref(db, `chats/${chatId}/recording/${currentUser}`), true);

      mediaRecorderRef.current.start();

      recordTimerRef.current = setInterval(() => {
        const secs = Math.floor((Date.now() - recordStartTimeRef.current) / 1000);
        const mins = Math.floor(secs / 60);
        const s = secs % 60;
        setRecordTime(`${mins}:${s.toString().padStart(2, '0')}`);
      }, 100);

    } catch (err) {
      if (err.name === 'NotAllowedError') showToast('Microphone blocked. Please allow in browser settings.');
      else showToast('Microphone error');
    }
  };

  const stopRecording = (e) => {
    if (e) e.preventDefault();
    if (!isRecording ||!mediaRecorderRef.current) return;

    const slideCancel = e && e.type === 'touchend' && e.changedTouches[0].clientX < window.innerWidth * 0.5;

    setIsRecording(false);
    clearInterval(recordTimerRef.current);

    if (slideCancel) {
      mediaRecorderRef.current.stop();
      const chatId = [currentUser, activeChat].sort().join('_');
      set(ref(db, `chats/${chatId}/recording/${currentUser}`), false);
      showToast('Cancelled');
    } else {
      mediaRecorderRef.current.stop();
    }
  };

  const sendVoiceMessage = (duration) => {
    if (!duration || isNaN(duration) || duration < 0.5) {
      showToast('Recording too short');
      return;
    }

    const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      const chatId = [currentUser, activeChat].sort().join('_');
      push(ref(db, `chats/${chatId}`), {
        sender: currentUser,
        type: 'voice',
        audioData: base64,
        duration: Math.round(duration),
        time: Date.now(),
        status: 'sent'
      });
    };
    reader.readAsDataURL(audioBlob);
  };

  const playVoice = (audioData, duration, btnElement) => {
    if (!audioData ||!duration || isNaN(duration)) return;

    const icon = btnElement.querySelector('i');
    const voiceMsg = btnElement.closest('.voice-msg');
    const waveBars = voiceMsg.querySelectorAll('.wave-bar');
    const timeDisplay = voiceMsg.querySelector('.time-display');

    document.querySelectorAll('.voice-msg').forEach(vm => {
      if (vm!== voiceMsg) {
        const otherBtn = vm.querySelector('button i');
        const otherBars = vm.querySelectorAll('.wave-bar');
        const otherTime = vm.querySelector('.time-display');
        const otherDur = parseInt(vm.getAttribute('data-duration'));
        if (otherBtn) otherBtn.className = 'ri-play-circle-fill';
        otherBars.forEach(b => b.classList.remove('filled'));
        if (otherTime &&!isNaN(otherDur)) otherTime.textContent = otherDur + 's';
      }
    });

    if (currentAudioRef.current && currentAudioRef.current.src === audioData) {
      if (currentAudioRef.current.paused) {
        currentAudioRef.current.play();
        icon.className = 'ri-pause-fill';
      } else {
        currentAudioRef.current.pause();
        icon.className = 'ri-play-fill';
      }
      return;
    }

    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }

    currentAudioRef.current = new Audio(audioData);
    icon.className = 'ri-pause-fill';

    currentAudioRef.current.ontimeupdate = () => {
      const currentTime = currentAudioRef.current.currentTime;
      const remaining = Math.max(0, Math.ceil(duration - currentTime));
      const progress = currentTime / duration;
      const barsToFill = Math.floor(progress * waveBars.length);

      waveBars.forEach((bar, idx) => {
        if (idx < barsToFill) bar.classList.add('filled');
        else bar.classList.remove('filled');
      });

      timeDisplay.textContent = remaining + 's';
    };

    currentAudioRef.current.onpause = () => icon.className = 'ri-play-fill';
    currentAudioRef.current.onplay = () => icon.className = 'ri-pause-fill';
    currentAudioRef.current.onended = () => {
      icon.className = 'ri-play-fill';
      waveBars.forEach(b => b.classList.remove('filled'));
      timeDisplay.textContent = duration + 's';
      currentAudioRef.current = null;
    };

    currentAudioRef.current.play().catch(err => {
      icon.className = 'ri-play-fill';
      showToast('Audio play failed');
    });
  };

  const seekAudio = (e, audioData, duration) => {
    if (!currentAudioRef.current || currentAudioRef.current.src!== audioData) return;
    const progressWrap = e.currentTarget;
    const rect = progressWrap.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const percent = Math.max(0, Math.min(1, clickX / width));
    currentAudioRef.current.currentTime = percent * duration;
  };


  const startCall = async () => {
    if (!activeChat) return showToast('Select a chat first');
    const userData = users[activeChat];
    if (!userData?.peerId) return showToast('User not available');
    if (currentCallRef.current) return showToast('Already in a call');

    try {
      if (!localStreamRef.current ||!micPermissionGrantedRef.current) {
        localStreamRef.current = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
          video: false
        });
        micPermissionGrantedRef.current = true;
      }

      await set(ref(db, `calls/${activeChat}`), {
        from: currentUser,
        to: activeChat,
        status: 'calling',
        time: serverTimestamp()
      });
 const receiverDoc = await get(ref(db, `users/${activeChat}`));
    const receiverToken = receiverDoc.val()?.fcmToken;
    
    if (receiverToken) {
      await fetch('https://yhfuowcodysbsmosgybq.supabase.co/functions/v1/send-notification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          receiverToken: receiverToken,
          senderName: userProfile.name || currentUser,
          chatId: [currentUser, activeChat].sort().join('_'),
          type: 'call' // ye important hai
        })
      });
    }
      setCallModal({ active: true, name: activeChat, status: 'Calling...', incoming: false });

      const call = peerRef.current.call(userData.peerId, localStreamRef.current);
      currentCallRef.current = call;

      call.on('stream', (remoteStream) => {
        document.getElementById('remoteAudio').srcObject = remoteStream;
        setCallModal(prev => ({...prev, status: '00:00' }));
        update(ref(db, `calls/${activeChat}`), { status: 'connected' });
        startCallTimer();
        logCallToChat('outgoing', activeChat);
      });

      call.on('close', () => endCallCleanup());
      call.on('error', () => endCallCleanup());

      setTimeout(() => {
        if (callModal.status === 'Calling...') {
          endCallCleanup();
          showToast('No answer');
          logCallToChat('missed', activeChat);
        }
      }, 30000);

    } catch (err) {
      showToast('Microphone error');
      endCallCleanup();
    }
  };

  const showIncomingCall = (fromUser) => {
    if (currentCallRef.current || callModal.active) return;
    setCallModal({ active: true, name: fromUser, status: 'Incoming call...', incoming: true });
    ringtoneRef.current?.play();
  };

  const acceptCall = async () => {
    try {
      if (!localStreamRef.current ||!micPermissionGrantedRef.current) {
        localStreamRef.current = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
          video: false
        });
        micPermissionGrantedRef.current = true;
      }

      ringtoneRef.current?.pause();
      setCallModal(prev => ({...prev, incoming: false, status: 'Connecting...' }));

      if (currentCallRef.current) {
        currentCallRef.current.answer(localStreamRef.current);
        currentCallRef.current.on('stream', (remoteStream) => {
          document.getElementById('remoteAudio').srcObject = remoteStream;
          setCallModal(prev => ({...prev, status: '00:00' }));
          startCallTimer();
        });
        currentCallRef.current.on('close', () => endCallCleanup());
        logCallToChat('incoming', callModal.name);
      }
      update(ref(db, `calls/${currentUser}`), { status: 'connected' });
    } catch (err) {
      showToast('Microphone access denied');
      endCallCleanup();
    }
  };

  const endCall = () => {
    remove(ref(db, `calls/${currentUser}`));
    if (activeChat) remove(ref(db, `calls/${activeChat}`));
    endCallCleanup();
  };

  const endCallCleanup = () => {
    stopCallTimer();
    endCallUI();
    if (currentCallRef.current) {
      currentCallRef.current.close();
      currentCallRef.current = null;
    }
  };

  const endCallUI = () => {
    ringtoneRef.current?.pause();
    setCallModal({ active: false, name: '', status: '', incoming: false });
    const remoteAudio = document.getElementById('remoteAudio');
    if (remoteAudio) remoteAudio.srcObject = null;
  };

  const startCallTimer = () => {
    callSecondsRef.current = 0;
    if (callTimerRef.current) clearInterval(callTimerRef.current);
    callTimerRef.current = setInterval(() => {
      callSecondsRef.current++;
      const mins = Math.floor(callSecondsRef.current / 60).toString().padStart(2, '0');
      const secs = (callSecondsRef.current % 60).toString().padStart(2, '0');
      setCallModal(prev => ({...prev, status: `${mins}:${secs}` }));
    }, 1000);
  };

  const stopCallTimer = () => {
    if (callTimerRef.current) {
      clearInterval(callTimerRef.current);
      callTimerRef.current = null;
      callSecondsRef.current = 0;
    }
  };

  const logCallToChat = (type, username) => {
    const chatId = [currentUser, username].sort().join('_');
    let text = type === 'outgoing'? 'Outgoing call' : type === 'incoming'? 'Incoming call' : 'Missed call';
    push(ref(db, `chats/${chatId}`), {
      sender: 'system',
      type: 'call',
      callType: type,
      text: text,
      time: Date.now()
    });
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();

    if (date.toDateString() === now.toDateString()) {
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).toLowerCase();
    }

    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    }

    const diffDays = Math.floor((now - date) / (1000 * 60 * 24));
    if (diffDays < 7) {
      return date.toLocaleDateString('en-US', { weekday: 'long' });
    }

    return date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit'
    });
  };

  const getStatusText = (msg, isMe) => {
    if (!isMe) return null;
    if (msg.status === 'sent') return 'Sent';
    if (msg.status === 'delivered') return 'Delivered';
    if (msg.status === 'seen') return 'Seen';
    return 'Sent';
  };

  const chatUsers = Object.keys({...contacts,...allChats }).filter(u => users[u] && u.toLowerCase().includes(searchQuery.toLowerCase()));

  const canSeeProfilePhoto = (targetUser) => {
    if (!targetUser || targetUser === currentUser) return true;
    const userPrivacy = users[targetUser]?.privacy?.profilePhoto || 'everyone';
    if (userPrivacy === 'nobody') return false;
    if (userPrivacy === 'contacts' &&!contacts[targetUser]) return false;
    return true;
  };

  const canSeeLastSeen = (targetUser) => {
    if (!targetUser || targetUser === currentUser) return true;
    const userPrivacy = users[targetUser]?.privacy?.lastSeen || 'everyone';
    if (userPrivacy === 'nobody') return false;
    if (userPrivacy === 'contacts' &&!contacts[targetUser]) return false;
    return true;
  };

  const canSeeAbout = (targetUser) => {
    if (!targetUser || targetUser === currentUser) return true;
    const userPrivacy = users[targetUser]?.privacy?.about || 'everyone';
    if (userPrivacy === 'nobody') return false;
    if (userPrivacy === 'contacts' &&!contacts[targetUser]) return false;
    return true;
  };

  const getInitials = (username) => {
    if (!username) return '';
    return username[0].toUpperCase();
  };

  if (!currentUser) {
    return (
      <div className="login-screen">
        <div className="login-box">
          <h1><i className="ri-chat-3-fill"></i>ChatZooo</h1>
          <p>Private & Secure</p>
          <input type="text" placeholder="Username..." value={nameInput} onChange={(e) => setNameInput(e.target.value)} />
          <input type="password" placeholder="Password..." value={passInput} onChange={(e) => setPassInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && login()} />
          <button onClick={() => login()}><i className="ri-login-box-line"></i> Login / Register</button>
        </div>
        {toast && <div className="toast">{toast}</div>}
      </div>
    );
  }

  return (
    <div className="app active">
      <audio id="remoteAudio" autoPlay ref={ringtoneRef} src="https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3" loop />

      <div className={`sidebar ${activeChat && window.innerWidth <= 768? 'hidden' : ''}`}>
        <div className="sidebar-header" style={{ cursor: 'pointer' }} onClick={() => setShowProfile(true)}>
          <div className="user-info" style={{ flex: 1 }}>
            <div className="avatar">
              {userProfile.profilePic?
                <img src={userProfile.profilePic} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} alt="profile" /> :
                currentUser[0].toUpperCase()
              }
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <span id="userName" style={{ display: 'block', fontWeight: 600, fontSize: '16px' }}>{userProfile.name || currentUser}</span>
              <span style={{ display: 'block', fontSize: '13px', color: 'var(--text-secondary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {userProfile.about || 'Hey there! I am using ChatZooo'}
              </span>
            </div>
            <div className="sidebar-actions" onClick={(e) => e.stopPropagation()}>
              <i className="ri-logout-box-line" onClick={logout}></i>
            </div>
          </div>
        </div>
        <div className="search-box">
          <div className="search-wrapper">
            <i className="ri-search-line"></i>
            <input type="text" placeholder="Search contacts" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
          </div>
        </div>
        <button className="add-user-btn" onClick={() => setIsModalOpen(true)}>
          <i className="ri-user-add-line"></i> Add Contact
        </button>
        <div className="chats-list">
          {chatUsers.length === 0? (
            <div style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: '40px 20px' }}>No chats yet.<br />Add a contact!</div>
          ) : chatUsers.map(uname => (
            <div key={uname} className={`chat-item ${activeChat === uname? 'active' : ''}`} onClick={() => openChat(uname)}>
              <div className="avatar">
                {canSeeProfilePhoto(uname) && users[uname]?.profilePic?
                  <img src={users[uname].profilePic} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} /> :
                  uname[0].toUpperCase()
                }
              </div>
              <div className="chat-info">
                <h3>{uname} {users[uname]?.online && <span className="status-dot"></span>}</h3>
                <p>{lastMessages[uname]?.type === 'call'? lastMessages[uname].text : lastMessages[uname]?.type === 'voice'? '🎤 Voice message' : lastMessages[uname]?.type === 'gif'? 'GIF' : lastMessages[uname]?.text || 'Start chatting...'}</p>
              </div>
              <div className="chat-time">{lastMessages[uname]? formatTime(lastMessages[uname].time) : ''}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="chat-window">
        {!activeChat? (
          <div className="empty-chat">
            <i className="ri-chat-3-line"></i>
            <h2>ChatZooo</h2>
            <p>Add a contact to start messaging</p>
          </div>
        ) : (
          <div id="activeChat" style={{ display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden', flex: 1 }}>
            <div className="chat-header">
              <i className="ri-arrow-left-line back-btn" onClick={closeChatMobile}></i>
              <div className="avatar">
                {canSeeProfilePhoto(activeChat) && users[activeChat]?.profilePic?
                  <img src={users[activeChat].profilePic} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} /> :
                  activeChat[0].toUpperCase()
                }
              </div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <h3>{activeChat}</h3>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  {users[activeChat]?.online?
                    <span style={{ color: 'var(--bg-green)' }}>online</span> :
                    canSeeLastSeen(activeChat)? 'last seen ' + formatTime(users[activeChat]?.lastSeen) : ''
                  }
                </p>
              </div>
              <div className="chat-header-actions">
                <i className="ri-phone-fill" id="callBtn" onClick={startCall} style={{ opacity: users[activeChat]?.peerId? 1 : 0.3 }}></i>
              </div>
            </div>
            <div className="messages">
              {messages.length === 0? (
  <div style={{ textAlign: 'center', color: 'var(--text-secondary)', marginTop: '40px' }}>
    No messages yet. Say hi! 👋
  </div>
) : messages.map((msg, i) => {
  if (!msg || typeof msg!== 'object') return null;

  const isMe = msg.sender === currentUser;
  const senderProfile = users[msg.sender]?.profilePic;

  if (msg.type === 'call') {
    return (
      <div key={i} className="message call-log">
        <i className={msg.callType === 'missed'? 'ri-phone-missed-line' : 'ri-phone-line'}></i>
        {msg.text} • {formatTime(msg.time)}
      </div>
    );
  }

       if (msg.type === 'image') {
                  const msgId = Object.keys(messages).find(key => messages[key] === msg);
                  return (
                    <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
                      {!isMe && (
                        <div className="avatar-mini">
                          {canSeeProfilePhoto(msg.sender) && senderProfile? (
                            <img src={senderProfile} alt="dp" />
                          ) : (
                            msg.sender?.[0]?.toUpperCase() || '?'
                          )}
                        </div>
                      )}
                      <div className="msg-content">
                        <div className="image-msg">
                          {msg.uploading? (
                            <div className="upload-progress-premium">
                              {msg.thumbnail && <img src={msg.thumbnail} className="blur-thumbnail" alt="uploading" />}
                              <div className="progress-overlay-premium">
                                <svg className="progress-ring" width="60" height="60">
                                  <circle className="progress-ring-bg" cx="30" cy="30" r="26" />
                                  <circle
                                    className="progress-ring-fill"
                                    cx="30" cy="30" r="26"
                                    style={{
                                      strokeDashoffset: 163 - (163 * (uploadProgress[msgId] || msg.progress || 0) / 100)
                                    }}
                                  />
                                </svg>
                                <div className="progress-text">{uploadProgress[msgId] || msg.progress || 0}%</div>
                              </div>
                            </div>
                          ) : (
                            <img
                              src={msg.url}
                              style={{ maxWidth: '250px', borderRadius: '7.5px', cursor: 'pointer' }}
                              onClick={() => setPreviewModal({ active: true, type: 'image', url: msg.url, name: msg.fileName })}
                              alt={msg.fileName}
                              loading="lazy"
                            />
                          )}
                          <div className="msg-time">
                            {formatTime(msg.time)}
                            {isMe && <span style={{ marginLeft: '8px', fontSize: '11px', color: msg.status === 'seen'? '#53bdeb' : 'var(--text-secondary)' }}>
                              {getStatusText(msg, isMe)}
                            </span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }


  if (msg.type === 'video') {
  const msgId = Object.keys(messages).find(key => messages[key] === msg);
  return (
    <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
      {!isMe && (
        <div className="avatar-mini">
          {canSeeProfilePhoto(msg.sender) && senderProfile? (
            <img src={senderProfile} alt="dp" />
          ) : (
            msg.sender?.[0]?.toUpperCase() || '?'
          )}
        </div>
      )}
      <div className="msg-wrapper">
        <div className="msg-content">
          <div className="msg-text video-msg-bubble">
            <div className="video-thumb-wrapper" onClick={() => setPreviewModal({ active: true, type: 'video', url: msg.url, name: msg.fileName })}>
              {msg.uploading? (
                <div className="upload-progress-premium">
                  {msg.thumbnail && <img src={msg.thumbnail} className="blur-thumbnail" alt="uploading" />}
                  <div className="progress-overlay-premium">
                    <svg className="progress-ring" width="60" height="60">
                      <circle className="progress-ring-bg" cx="30" cy="30" r="26" />
                      <circle
                        className="progress-ring-fill"
                        cx="30" cy="30" r="26"
                        style={{
                          strokeDashoffset: 163 - (163 * (uploadProgress[msgId] || msg.progress || 0) / 100)
                        }}
                      />
                    </svg>
                    <div className="progress-text">{uploadProgress[msgId] || msg.progress || 0}%</div>
                  </div>
                </div>
              ) : (
                <>
                  {msg.thumbnail? (
                    <img src={msg.thumbnail} alt="video" />
                  ) : (
                    <video src={msg.url} preload="metadata" muted />
                  )}
                  <div className="video-play-btn">
                    <i className="ri-play-fill"></i>
                  </div>
                </>
              )}
            </div>
            <div className="msg-time-inline">
              {formatTime(msg.time)}
            </div>
          </div>
        </div>
        {isMe && (
          <div className={`msg-status-outside ${msg.status === 'seen'? 'seen' : ''}`}>
            {msg.status === 'seen'? 'Seen' : msg.status === 'delivered'? 'Delivered' : 'Sent'}
          </div>
        )}
      </div>
    </div>
  );
}

if (msg.type === 'document' || msg.type === 'audio' || msg.type === 'file') {
  const msgId = Object.keys(messages).find(key => messages[key] === msg);

  const getFileIcon = (fileName, fileType) => {
    if (fileType?.includes('pdf')) return 'ri-file-pdf-fill';
    if (fileType?.includes('audio')) return 'ri-file-music-fill';
    if (fileType?.includes('zip') || fileType?.includes('rar')) return 'ri-file-zip-fill';
    if (fileType?.includes('word') || fileName?.endsWith('.doc') || fileName?.endsWith('.docx')) return 'ri-file-word-fill';
    if (fileType?.includes('excel') || fileName?.endsWith('.xls') || fileName?.endsWith('.xlsx')) return 'ri-file-excel-fill';
    if (fileType?.includes('presentation') || fileName?.endsWith('.ppt') || fileName?.endsWith('.pptx')) return 'ri-file-ppt-fill';
    return 'ri-file-text-fill';
  };

  const getFileColor = (fileName, fileType) => {
    if (fileType?.includes('pdf')) return '#F40F02';
    if (fileType?.includes('audio')) return '#FF6B00';
    if (fileType?.includes('word')) return '#2B579A';
    if (fileType?.includes('excel')) return '#217346';
    if (fileType?.includes('presentation')) return '#D24726';
    return '#00A884';
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
      {!isMe && (
        <div className="avatar-mini">
          {canSeeProfilePhoto(msg.sender) && senderProfile? (
            <img src={senderProfile} alt="dp" />
          ) : (
            msg.sender?.[0]?.toUpperCase() || '?'
          )}
        </div>
      )}
      <div className="msg-wrapper">
        <div className="msg-content">
          <div className="msg-text doc-bubble" onClick={() =>!msg.uploading && setPreviewModal({
            active: true,
            type: msg.fileType?.includes('pdf')? 'pdf' : 'document',
            url: msg.url,
            name: msg.fileName
          })}>
            <div className="doc-content">
              <div className="doc-icon-box" style={{ backgroundColor: getFileColor(msg.fileName, msg.fileType) }}>
                {msg.uploading? (
                  <div className="doc-progress">{uploadProgress[msgId] || msg.progress || 0}%</div>
                ) : (
                  <i className={getFileIcon(msg.fileName, msg.fileType)}></i>
                )}
              </div>
              <div className="doc-info">
                <div className="doc-name">{msg.fileName}</div>
                <div className="doc-size">{formatFileSize(msg.fileSize)}</div>
              </div>
            </div>
            <div className="msg-time-inline">
              {formatTime(msg.time)}
            </div>
          </div>
        {isMe && (
          <div className={`msg-status-outside ${msg.status === 'seen'? 'seen' : ''}`}>
            {msg.status === 'seen'? 'Seen' : msg.status === 'delivered'? 'Delivered' : 'Sent'}
          </div>
        )}
            </div> 
          </div> 
        </div> 
    
  );
}
                if (msg.type === 'voice') {
                  const dur = Math.round(msg.duration) || 0;
                  return (
                    <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
                      <div className="msg-content">
                        <div className="voice-msg" data-duration={dur}>
                          <button onClick={(e) => playVoice(msg.audioData, dur, e.currentTarget)}>
                            <i className="ri-play-circle-fill"></i>
                          </button>
                          <div className="progress-wrap" onClick={(e) => seekAudio(e, msg.audioData, dur)}>
                            <div className="waveform">
                              {Array(30).fill(0).map((_, j) => <div key={j} className="wave-bar"></div>)}
                            </div>
                          </div>
                          <div className="avatar-mini">
                            {users[msg.sender]?.profilePic? (
                              <img src={users[msg.sender].profilePic} alt="" />
                            ) : (
                              msg.sender?.charAt(0)?.toUpperCase() || '?'
                            )}
                          </div>
                          <span className="time-display">{dur}s</span>
                          <div className="msg-time">
                            {formatTime(msg.time)}
                            {isMe && <span style={{ marginLeft: '8px', fontSize: '11px', color: msg.status === 'seen'? '#53bdeb' : 'var(--text-secondary)' }}>
                              {getStatusText(msg, isMe)}
                            </span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }

                if (msg.type === 'gif') {
                  return (
                    <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
                      {!isMe && (
                        <div className="avatar-mini">
                          {canSeeProfilePhoto(msg.sender) && senderProfile? (
                            <img src={senderProfile} alt="dp" />
                          ) : (
                            msg.sender?.[0]?.toUpperCase() || '?'
                          )}
                        </div>
                      )}
                      <div className="msg-content">
                        <img src={msg.url} style={{ maxWidth: '240px', borderRadius: '7.5px', boxShadow: '0 1px 0.5px rgba(0,0,0.13)' }} alt="gif" />
                        <div className="msg-time">
                          {formatTime(msg.time)}
                          {isMe && <span style={{ marginLeft: '8px', fontSize: '11px', color: msg.status === 'seen'? '#53bdeb' : 'var(--text-secondary)' }}>
                            {getStatusText(msg, isMe)}
                          </span>}
                        </div>
                      </div>
                    </div>
                  );
                }

              
return (
                  <div key={i} className={`message ${isMe? 'out' : 'in'}`}>
                    {!isMe && (
                      <div className="avatar-mini">
                        {canSeeProfilePhoto(msg.sender) && senderProfile? (
                          <img src={senderProfile} alt="dp" />
                        ) : (
                          msg.sender?.[0]?.toUpperCase() || '?'
                        )}
                      </div>
                    )}
                    <div className="msg-wrapper">
                      <div className="msg-content">
                        <div className="msg-text">
                          <span className="msg-body">{msg.text}</span>
                          <span className="msg-time-inline">{formatTime(msg.time)}</span>
                        </div>
                      </div>
                      {isMe && (
                        <div className={`msg-status-outside ${msg.status === 'seen'? 'seen' : ''}`}>
                          {msg.status === 'seen'? 'Seen' : msg.status === 'delivered'? 'Delivered' : 'Sent'}
                        </div>
                      )}
                    </div>
                  </div>
                   
                );
              })}

              {isTyping && (
                <div className="message in typing-bubble">
                  <div className="avatar-mini">
                    {canSeeProfilePhoto(activeChat) && users[activeChat]?.profilePic? (
                      <img src={users[activeChat].profilePic} alt="dp" />
                    ) : (
                      activeChat[0]?.toUpperCase() || '?'
                    )}
                  </div>
                  <div className="msg-content">
                    <div className="msg-text typing-premium-pencil">
                      <div className="pencil-container">
                        <i className="ri-pencil-fill"></i>
                        <div className="writing-line"></div>
                      </div>
                      <span></span>
                    </div>
                  </div>
                </div>
              )}

              {isRecordingOther && (
                <div className="message in recording-bubble">
                  <div className="avatar-mini">
                    {canSeeProfilePhoto(activeChat) && users[activeChat]?.profilePic? (
                      <img src={users[activeChat].profilePic} alt="dp" />
                    ) : (
                      activeChat[0]?.toUpperCase() || '?'
                    )}
                  </div>
                  <div className="msg-content">
                    <div className="msg-text voice-recording-premium">
                      <div className="mic-pulse">
                        <i className="ri-mic-fill"></i>
                      </div>
                      <div className="recording-waves">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span className="recording-text">Recording</span>
                    </div>
                  </div>
                </div>
              )}

              <div ref={messagesEndRef} />
            </div>
            <div className="chat-input-area">
              <i className="ri-emotion-happy-line" onClick={() => {
                setIsEmojiPickerOpen(!isEmojiPickerOpen);
                setShowAttachmentMenu(false);
                if (!isEmojiPickerOpen) setTimeout(() => initEmojiPicker(), 50);
              }}></i>

              <div className="attachment-wrapper">
                <i className="ri-attachment-2" onClick={() => {
                  setShowAttachmentMenu(!showAttachmentMenu);
                  setIsEmojiPickerOpen(false);
                }}></i>

                {showAttachmentMenu && (
                  <div className="attachment-menu">
                    {attachmentOptions.map((opt, idx) => (
                      <div key={idx} className="attachment-option" onClick={opt.action}>
            <div className="attachment-icon" style={{background: opt.color}}>
              <i className={opt.icon}></i>
            </div>
            <span>{opt.label}</span>
          </div>
        ))}
      </div>
    )}
  </div>

  <input
    type="file"
    ref={fileInputRef}
    style={{display:'none'}}
    onChange={handleFileSelect}
    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
  />

  <input
    type="file"
    ref={imageInputRef}
    style={{display:'none'}}
    onChange={handleFileSelect}
    accept="image/*,video/*"
  />

  <div className={`emoji-picker ${isEmojiPickerOpen? 'active' : ''}`} ref={emojiPickerRef}>
    <div className="emoji-tabs">
      <button className={`emoji-tab ${activeEmojiTab === 'emoji'? 'active' : ''}`} onClick={() => {
        setActiveEmojiTab('emoji');
        emojiPickerLoaded.current = false;
        setTimeout(() => initEmojiPicker(), 50);
      }}>😊</button>
      <button className={`emoji-tab ${activeEmojiTab === 'gif'? 'active' : ''}`} onClick={() => {
        setActiveEmojiTab('gif');
        if (gifResults.length === 0) loadGifs('trending', 'gif');
      }}>GIF</button>
      <button className={`emoji-tab ${activeEmojiTab === 'sticker'? 'active' : ''}`} onClick={() => {
        setActiveEmojiTab('sticker');
        if (stickerResults.length === 0) loadGifs('happy', 'sticker');
      }}>⭐</button>
    </div>
    {activeEmojiTab === 'emoji' && <div id="emojiContent" style={{padding:'8px',flex:1,overflowY:'auto'}}></div>}
    {activeEmojiTab === 'gif' && (
      <div style={{padding:'8px',flex:1,overflowY:'auto'}}>
        <input type="text" placeholder="Search GIFs..." onChange={(e) => e.target.value.length > 2 && loadGifs(e.target.value, 'gif')} style={{width:'100%',padding:'8px',background:'var(--bg-primary)',border:'1px solid var(--border-color)',color:'var(--text-primary)',borderRadius:'8px',marginBottom:'8px',outline:'none'}} />
        <div style={{display:'grid',gridTemplateColumns:'repeat(3, 1fr)',gap:'8px'}}>
          {gifResults.map((gif, idx) => {
            if (gif.loading) return <div key={idx} style={{gridColumn:'1/-1',textAlign:'center',color:'var(--text-secondary)',padding:'20px'}}>Loading...</div>;
            if (!gif?.media_formats?.tinygif?.url) return null;
return <img key={idx} src={gif.media_formats.tinygif.url} onClick={() => sendGif(gif.media_formats.gif.url)} alt="gif" style={{cursor:'pointer',width:'100%',height:'90px',objectFit:'cover',borderRadius:'8px'}} loading="lazy" />;
          })}
        </div>
      </div>
    )}
    {activeEmojiTab === 'sticker' && (
      <div style={{padding:'8px',flex:1,overflowY:'auto'}}>
        <input type="text" placeholder="Search Stickers..." onChange={(e) => e.target.value.length > 2 && loadGifs(e.target.value, 'sticker')} style={{width:'100%',padding:'8px',background:'var(--bg-primary)',border:'1px solid var(--border-color)',color:'var(--text-primary)',borderRadius:'8px',marginBottom:'8px',outline:'none'}} />
        <div style={{display:'grid',gridTemplateColumns:'repeat(3, 1fr)',gap:'8px'}}>
          {stickerResults.map((gif, idx) => {
            if (gif.loading) return <div key={idx} style={{gridColumn:'1/-1',textAlign:'center',color:'var(--text-secondary)',padding:'20px'}}>Loading...</div>;
            if (!gif?.media_formats?.tinygif?.url) return null;
            return <img key={idx} src={gif.media_formats.tinygif.url} onClick={() => sendGif(gif.media_formats.gif.url)} alt="sticker" style={{cursor:'pointer',width:'100%',height:'90px',objectFit:'cover',borderRadius:'8px'}} loading="lazy" />;
          })}
        </div>
      </div>
    )}
  </div>

  <div className="input-wrapper" id="inputWrapper">
    {!isRecording? (
      <input
        type="text"
        id="msgInput"
        placeholder="Type a message"
        value={msgInput}
        onChange={(e) => {
          setMsgInput(e.target.value);
          handleTyping();
        }}
        onKeyPress={handleKeyPress}
      />
    ) : (
      <div id="recordingUI" style={{display:'flex',flex:1,alignItems:'center',gap:'12px'}}>
        <i className="ri-mic-fill" style={{color:'var(--red)',animation:'pulse 1s infinite'}}></i>
        <span id="recordTime" style={{fontSize:'15px'}}>{recordTime}</span>
        <span style={{flex:1,textAlign:'center',color:'var(--text-secondary)',fontSize:'13px'}}><i className="ri-arrow-left-line"></i> Slide to cancel</span>
      </div>
    )}
  </div>

  <button className="send-btn" id="micBtn" onMouseDown={startRecording} onMouseUp={stopRecording} onTouchStart={startRecording} onTouchEnd={stopRecording} style={{display: msgInput.trim()? 'none' : 'flex'}}>
    <i className="ri-mic-fill" id="micIcon"></i>
  </button>
  <button className="send-btn" id="sendBtn" onClick={sendMessage} style={{display: msgInput.trim()? 'flex' : 'none'}}>
    <i className="ri-send-plane-fill"></i>
  </button>
</div>
</div>
)}
</div>

{isModalOpen && (
<div className="modal active">
  <div className="modal-box">
    <h2>Add New Contact</h2>
    <input type="text" placeholder="Enter exact username..." value={newUserName} onChange={(e) => setNewUserName(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && addUser()} />
    <div className="modal-actions">
      <button className="btn-cancel" onClick={() => {setIsModalOpen(false); setNewUserName('');}}>Cancel</button>
      <button className="btn-add" onClick={addUser}>Add Contact</button>
    </div>
  </div>
</div>
)}

{callModal.active && (
<div className="call-modal active">
  <div className="call-box">
    <div className="call-avatar">{callModal.name[0]?.toUpperCase() || '?'}</div>
    <h2>{callModal.name}</h2>
    <p>{callModal.status}</p>
    <div className="call-actions">
      <button className="call-btn reject" onClick={endCall}>
        <i className="ri-close-line"></i>
      </button>
      {callModal.incoming && (
        <button className="call-btn accept" onClick={acceptCall}>
          <i className="ri-phone-fill"></i>
        </button>
      )}
    </div>
  </div>
</div>
)}
{showProfile && (
<div className="profile-modal active">
  <div className="profile-box">
    <div className="profile-header">
      <i className="ri-arrow-left-line" onClick={() => setShowProfile(false)}></i>
      <h2>Profile</h2>
    </div>

    <div className="profile-tabs">
      <button className={profileTab === 'profile'? 'active' : ''} onClick={() => setProfileTab('profile')}>Profile</button>
      <button className={profileTab === 'privacy'? 'active' : ''} onClick={() => setProfileTab('privacy')}>Privacy</button>
      <button className={profileTab === 'account'? 'active' : ''} onClick={() => setProfileTab('account')}>Account</button>
    </div>

    {profileTab === 'profile' && (
      <div className="profile-content">
        <div className="profile-pic-section">
          <div className="profile-pic-large">
            {userProfile.profilePic?
              <img src={userProfile.profilePic} alt="profile" /> :
              <span>{currentUser[0]?.toUpperCase() || '?'}</span>
            }
          </div>
          <label className="camera-icon">
            <i className="ri-camera-fill"></i>
            <input type="file" accept="image/*" onChange={handleProfilePicChange} style={{display:'none'}} />
          </label>
        </div>

        <div className="profile-field">
          <label>Your name</label>
          <input type="text" value={userProfile.name} onChange={(e) => updateProfile('name', e.target.value)} />
        </div>

        <div className="profile-field">
          <label>About</label>
          <input type="text" value={userProfile.about} onChange={(e) => updateProfile('about', e.target.value)} placeholder="Hey there! I am using ChatZooo" />
        </div>

      </div>
    )}

    {profileTab === 'privacy' && (
      <div className="profile-content">
        <div className="privacy-item">
          <div>
            <h4>Last seen and online</h4>
            <p>Who can see your last seen</p>
          </div>
          <select value={userProfile.privacy.lastSeen} onChange={(e) => updatePrivacy('lastSeen', e.target.value)}>
            <option value="everyone">Everyone</option>
            <option value="contacts">My contacts</option>
            <option value="nobody">Nobody</option>
          </select>
        </div>

        <div className="privacy-item">
          <div>
            <h4>Profile photo</h4>
            <p>Who can see your profile photo</p>
          </div>
          <select value={userProfile.privacy.profilePhoto} onChange={(e) => updatePrivacy('profilePhoto', e.target.value)}>
            <option value="everyone">Everyone</option>
            <option value="contacts">My contacts</option>
            <option value="nobody">Nobody</option>
          </select>
        </div>

        <div className="privacy-item">
          <div>
            <h4>Read receipts</h4>
            <p>Send read receipts</p>
          </div>
          <label className="switch">
            <input type="checkbox" checked={userProfile.privacy.readReceipts} onChange={(e) => updatePrivacy('readReceipts', e.target.checked)} />
            <span className="slider"></span>
          </label>
        </div>
      </div>
    )}

    {profileTab === 'account' && (
      <div className="profile-content">
        <div className="privacy-item" style={{cursor:'pointer'}} onClick={() => {
          if(confirm('Delete your account? This cannot be undone.')) {
            remove(ref(db, `users/${currentUser}`));
            remove(ref(db, `profiles/${currentUser}`));
            logout();
          }
        }}>
          <div>
            <h4 style={{color:'var(--red)'}}>Delete my account</h4>
          </div>
          <i className="ri-delete-bin-line" style={{color:'var(--red)'}}></i>
        </div>
      </div>
    )}
  </div>
</div>
)}
{previewModal.active && (
<div className="preview-modal" onClick={() => setPreviewModal({ active: false })}>
  <div className="preview-header">
    <span>{previewModal.name}</span>
    <i className="ri-close-line" onClick={() => setPreviewModal({ active: false })}></i>
  </div>
  <div className="preview-content" onClick={(e) => e.stopPropagation()}>
    {previewModal.type === 'image' && (
      <img src={previewModal.url} alt={previewModal.name} />
    )}
    {previewModal.type === 'video' && (
      <video src={previewModal.url} controls autoPlay />
    )}
    {previewModal.type === 'pdf' && (
      <iframe src={previewModal.url} width="100%" height="100%" />
    )}
    {previewModal.type === 'document' && (
      <div className="doc-preview">
        <i className="ri-file-line"></i>
        <p>{previewModal.name}</p>
        <a href={previewModal.url} download={previewModal.name} className="download-btn">
          <i className="ri-download-line"></i> Download
        </a>
      </div>
    )}
  </div>
</div>
)}

{toast && <div className="toast">{toast}</div>}
</div>
);
}

export default App;